var genID = function () {
  var count = 0;
  return function () {
    return (count++).toString();
  };
}();

export { genID };
//# sourceMappingURL=genID.js.map
